import { Chip } from "@mui/material";
import { words } from "es-toolkit/string";
import { AssetNameWithIcon } from "src/components/resources/AssetNameWithIcon/AssetNameWithIcon";
import type { AssetType } from "src/components/resources/AssetNameWithIcon/AssetNameWithIcon.props";

const GlobalSearchAssetChip = ({ type }: { type: string }) => {
  const wordParts = words(type) as string[]; // "taskRun" -> ["task", "run"]
  const name = wordParts.join(" ").toLowerCase(); // "task run"
  type = wordParts[0]; // "task"

  return (
    <Chip
      size="small"
      variant="outlined"
      sx={{
        width: 115,
        justifyContent: "start",
      }}
      label={
        <div className="flex items-center gap-2">
          <AssetNameWithIcon
            name={name}
            type={type as AssetType}
            className="capitalize"
            sx={{ color: "text.primary" }}
          />
        </div>
      }
    />
  );
};

export default GlobalSearchAssetChip;
